import React from "react";

import FarmRow from "./FarmRow";

type Props = {
  pairs: any;
};

const FarmTableCard: React.FC<Props> = ({ pairs = [] }) => (
  <table className="px-20 bg-white rounded-lg bg-opacity-10 w-full table-fixed">
    <thead className="bg-white bg-opacity-10 text-white ">
      <tr>
        <th className="py-3">Pair</th>
        <th>My LP Amount</th>
        <th>My Staked LP Amount</th>
        <th />
      </tr>
    </thead>
    <tbody className="text-white">
      {pairs.map((item: any, index: number) => (
        <FarmRow pair={item} key={index} />
      ))}
    </tbody>
  </table>
);

export default FarmTableCard;
